import { Box, Typography } from '@mui/material';

interface PromotionTooltipContentProps {
  promotions: Array<any>;
}

const PromotionTooltipContent = ({
  promotions,
}: PromotionTooltipContentProps) => (
  <Box component="ul">
    {promotions
      ?.filter((promotion) => promotion.validNow)
      .map((promotion: any) => (
        <Box component="li" key={promotion.uuid} sx={{ paddingY: 1 }}>
          <Typography variant="subtitle2">
            <div dangerouslySetInnerHTML={{ __html: promotion.description }} />
          </Typography>
        </Box>
      ))}
  </Box>
);
export default PromotionTooltipContent;
